import { useEffect, useState } from "react";
import { FileText, Download } from "lucide-react";
import { Company, CheckCompany, CheckCompanyProvidedDocument, isCheckError, CheckResponseError } from "winslow-core";
import { apiCheckListCompanyProvidedDocuments } from "../../../services/PayrollService";
import "./AppPayCompanyOnboardingStatus.css";
import "./AppPayConfiguration.css";
import toast from "react-hot-toast";
import { toastFail } from "../../../config";
import { AppCheckErrorMessage } from "./AppCheckErrorMessage";

type AppPayFilingsProps = {
    company: Company | null;
    checkCompany: CheckCompany | null;
};

export const AppPayFilings = ({ company, checkCompany }: AppPayFilingsProps) => {
    const [checkCompanyProvidedDocuments, setCheckCompanyProvidedDocuments] = useState<CheckCompanyProvidedDocument[]>([]);
    const [loadingDocuments, setLoadingDocuments] = useState<boolean>(false);

    const [checkResponseError, setCheckResponseError] = useState<CheckResponseError | undefined>(undefined);

    useEffect(() => {
        const loadDocuments = async () => {
            if (!checkCompany?.id) {
                return;
            }

            setLoadingDocuments(true);
            try {

                const apiResponse = await apiCheckListCompanyProvidedDocuments(checkCompany.id);
                const docs = apiResponse?.data;
                setCheckResponseError(apiResponse?.checkResponseError);

                if (!apiResponse || isCheckError(apiResponse) || !docs) {
                    toast("Error loading documents", toastFail);
                    return;
                }

                setCheckCompanyProvidedDocuments(docs);
            } catch (error) {
                console.error("[AppPayFilings] Error loading documents:", error);
            } finally {
                setLoadingDocuments(false);
            }
        };

        loadDocuments();
    }, [checkCompany?.id]);



    const handleDownloadDocument = (document: CheckCompanyProvidedDocument) => {
        if (document.upload_url) {
            window.open(document.upload_url, '_blank');
        }
    };

    console.log("[AppPayFilings] check company: ", checkCompany);
    
    return (
        <div className="app-pay-configuration-content">
            <h2>Filings</h2>

            <AppCheckErrorMessage checkResponseError={checkResponseError} />

            {checkCompanyProvidedDocuments.length > 0 && (
                <div className="onboarding-items-table-container" style={{ marginBottom: '32px' }}>
                    <h3 className="onboarding-items-title">Company Provided Documents</h3>
                    {loadingDocuments ? (
                        <p>Loading documents...</p>
                    ) : (
                        <table className="onboarding-items-table">
                            <thead>
                                <tr>
                                    <th>Document Type</th>
                                    <th>Status</th>
                                    <th>File Name</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {checkCompanyProvidedDocuments.map((document) => (
                                    <tr key={document.id}>
                                        <td>
                                            <span className="issue-type-label">
                                                <FileText size={16} className="issue-type-icon" />
                                                {document.document_type.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())}
                                            </span>
                                        </td>
                                        <td>
                                            <span className={document.upload_status === "uploaded" ? "blocking-badge non-blocking" : "blocking-badge blocking"}>
                                                {document.upload_status === "uploaded" ? "Uploaded" : "Pending"}
                                            </span>
                                        </td>
                                        <td>
                                            <span className="issue-name">
                                                {document.provided_filename || "No filename"}
                                            </span>
                                        </td>
                                        <td>
                                            {document.upload_status === "uploaded" && document.upload_url ? (
                                                <button
                                                    className="resolve-link-button"
                                                    onClick={() => handleDownloadDocument(document)}
                                                    type="button"
                                                >
                                                    Download
                                                    <Download size={14} className="resolve-link-icon" />
                                                </button>
                                            ) : (
                                                <span style={{ color: '#6b7280', fontSize: '14px' }}>Not available</span>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            )}

        </div>
    );
};

